export enum DatabaseFieldType {
  string = "string",
  id = "id",
}
